import objectToFormData from 'object-to-formdata';


export default function addPageAsWidget(appensThis,
	// Named (but not optional) parameters, as options object:
	{
		toPageId,
		elementName,
		parameters,
		settings,
	}
)
{
	appensThis.AjaxpostaOchHanteraResultat('/widget/add-widget', {
		formData: objectToFormData({
			pageId: toPageId,
			elementName,
			parameters,
			settings,
		}),

		doljSpinnerOnSuccess: true,

		onSuccessFunction: (resultat) => {
			// Visa lyckatmeddelande:
			appensThis.$notify({
				group: 'tc',
				text: 'Kortet har lagts till på översikts­sidan.',
				type: 'success',
			});
		},
	});
}
